// Client-specific localStorage helpers (separate from admin)
// This ensures client and admin authentication don't interfere with each other

export const clientStorage = {
  // Client Access Token
  getAccessToken: (): string | null => {
    return localStorage.getItem('clientAccessToken');
  },

  setAccessToken: (token: string): void => {
    localStorage.setItem('clientAccessToken', token);
  },

  // Client Refresh Token
  getRefreshToken: (): string | null => {
    return localStorage.getItem('clientRefreshToken');
  },

  setRefreshToken: (token: string): void => {
    localStorage.setItem('clientRefreshToken', token);
  },

  // Set both tokens at once
  setTokens: (accessToken: string, refreshToken: string): void => {
    localStorage.setItem('clientAccessToken', accessToken);
    localStorage.setItem('clientRefreshToken', refreshToken);
  },

  // Clear all client tokens
  clearTokens: (): void => {
    localStorage.removeItem('clientAccessToken');
    localStorage.removeItem('clientRefreshToken');
  },

  // Check if client has tokens
  hasTokens: (): boolean => {
    return !!localStorage.getItem('clientAccessToken');
  },
};

export default clientStorage;
